import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Achievements = () => {
  const achievements = [
    {
      year: "2024",
      title: "Smart India Hackathon Finalist",
      description:
        "Selected as a finalist at Smart India Hackathon (SIH) 2024 at NIT Kurukshetra."
    },
    {
      year: "2024",
      title: "Adobe GenSolve",
      description:
        "Ranked among the top 5% globally in Adobe GenSolve 2024."
    },
    {
      year: "2023",
      title: "Ninja Dominator League",
      description:
        "Secured Rank #1 in the Ninja Dominator League on Code360."
    },
    {
      year: "2022",
      title: "TechSpardha'22",
      description:
        "Secured 2nd place in the ChatBot competition at TechSpardha'22, NIT Kurukshetra."
    },
    {
      year: "DSA",
      title: "650+ Problems Solved",
      description:
        "Solved 650+ Data Structures and Algorithms problems across LeetCode, GeeksforGeeks, Code360, and HackerRank."
    }
  ];

  return (
    <section className="achievements" id="achievements">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__slideInUp"
                      : ""
                  }
                >
                  <h2>Achievements</h2>

                  <p className="achievements-intro">
                    A few milestones from competitive programming,
                    hackathons, and technical competitions.
                  </p>
                </div>
              )}
            </TrackVisibility>

            <Row className="achievement-row">
              {achievements.map((achievement, index) => (
                <Col
                  key={index}
                  xs={12}
                  md={6}
                  lg={4}
                  className="achievement-col"
                >
                  <TrackVisibility>
                    {({ isVisible }) => (
                      <div
                        className={`achievement-card ${
                          isVisible
                            ? "animate__animated animate__fadeInUp"
                            : ""
                        }`}
                      >
                        <div className="achievement-year">
                          {achievement.year}
                        </div>

                        <h3>{achievement.title}</h3>

                        <p>{achievement.description}</p>
                      </div>
                    )}
                  </TrackVisibility>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
